import AbstractService from 'core/abstracts/AbstractService';
import Facade from 'core/Facade';

class CatalogService extends AbstractService {

    getCatalogs(options) {
        return this.request({
            method: 'GET',
            url:  Facade.getApiRoot() + `bo/catalogs?p=${options.page}&ps=${options.rowsPerPage}${options.site && `&sq=${options.site}`}${options.account && `&aq=${options.account}`}`,
        }).then(async (responseData) => {
            if (responseData.ok) {
                return {
                    count: responseData.headers.get('X-Total-Count'),
                    sites: await responseData.json()
                };
            }
            throw await responseData.json();
        });
    }

    getCatalog(id) {
        return this.request({
            method: 'GET',
            url:  Facade.getApiRoot() + 'bo/sites/' + id + '/catalog-stats',
        }).then(async (responseData) => {
            if (responseData.ok) {
                return await responseData.json();
            }
            throw await responseData.json();
        });
    }
}

export default new CatalogService();
